// <main> de LayoutWAM: con el panel del asistente abierto (pantallas medianas en
// adelante) le deja lugar a la derecha en vez de taparlo.
import React from 'react';
import { Box } from '@chakra-ui/react';
import { useAsistente } from './AsistenteContext';
import { ANCHO_PANEL } from './AsistentePanel';

const AsistenteMain = ({ children, ...props }) => {
  const { habilitado, abierto } = useAsistente();
  const ocupado = habilitado && abierto;
  return (
    <Box {...props} pr={{ base: 0, md: ocupado ? `${ANCHO_PANEL}px` : 0 }} data-asistente-abierto={ocupado ? 'si' : 'no'}>
      {children}
    </Box>
  );
};

export default AsistenteMain;
